import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    user: {}
  },
  mutations: {
    // 登录
    [types.LOGIN]: (state, data) => {
      localStorage.token = data
      console.log('Token:' + data)
      state.token = data
    },
    // 退出
    [types.LOGOUT]: (state) => {
      localStorage.removeItem('token')
      state.token = null
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js